<template>
  <hic-report-panel v-model="tmpls[tmplIndex]">
    <template slot="title">
      <el-dropdown v-if="tmpls[tmplIndex]" @command="handleCommand">
        <span class="sub-title pointer"> {{ tmpls[tmplIndex].name }} <i class="el-icon-arrow-down el-icon--right"></i> </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(tmpl, index) in tmpls" :key="tmpl.code" :command="index + ''">{{ tmpl.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </hic-report-panel>
</template>
<script>
  import { apiFuns } from "sw-hic";
  export default {
    name: "hic-report-page",
    props: {
      title: String,
    },
    data() {
      return {
        tmpls: [],
        tmplIndex: "0",
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        apiFuns.get("/api/report/report", { sys: this.$cfg.sys.code, type: "通用", disabled: false }).then((res) => {
          this.tmpls = res.items;
        });
      },
      handleCommand(idx) {
        this.tmplIndex = idx;
      },
    },
  };
</script>
